import config from "../app-config";
import serverFetch from "../utils/serverFetch";

export const fetch_all_breakfast_information = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/cafe/breakfast`,
        method: "GET",
        credentials: "include"
    });
}

export const fetch_breakfast_by_id = async (breakfast_id) => {
    if (!breakfast_id) return { error: "No breakfast id provided" };
    return await serverFetch({
        endpoint: `${config.endpoint}/cafe/breakfast/id/${breakfast_id}`,
        method: "GET",
        credentials: "include"
    });
}

export const create_new_breakfast = async (breakfast_data) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/cafe/breakfast`,
        method: "POST",
        body: JSON.stringify(breakfast_data),
        credentials: "include"
    });
}

export const update_breakfast_by_id = async (breakfast_id, breakfast_data) => {
    if (!breakfast_id) return { error: "No breakfast id provided" };
    return await serverFetch({
        endpoint: `${config.endpoint}/cafe/breakfast/id/${breakfast_id}`,
        method: "PUT",
        body: JSON.stringify(breakfast_data),
        credentials: "include"
    });
}

export const delete_breakfast_by_id = async (breakfast_id) => {
    if (!breakfast_id) return { error: "No breakfast id provided" };
    return await serverFetch({
        endpoint: `${config.endpoint}/cafe/breakfast/id/${breakfast_id}`,
        method: "DELETE",
        credentials: "include"
    });
}

export const fetch_upcoming_breakfast = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/cafe/breakfast/public`,
        method: "GET",
        credentials: "include"
    });
}
